const  en = {
  "releaseLocales": {
    "release": "Release",
    "releases": "Releases",
    "editRelease": "Edit release",
    "createRelease": "Create release",
    "confirmAndDistribute": "Confirm and distribute",
    "designAndPreview": "Design and preview",
    "landingPageDesign": "Landing page design",
    "newsletterDesign": "Newsletter design",
    "searchReleases": "Search releases",
    "filterByYear": "Filter by year",
    "allYears": "All years",
    "addToFolder": "Add to folder",
    "alerts": {
      "confirmRemove": "Are you sure you want to remove this release?",
      "removeSuccess": "Release removed successfully",
      "savedSuccess": "Release saved successfully",
      "leaveConfirm": "Leave without saving?"
    },

    purchase: 'Purchase',
    israeliPurchase: 'israeli purchase',
    original: 'Original',

    distributedAt: "Distributed at",

    
    "release": "Release",
    "releases": "Releases",
    "monthPublish": "Month of publish",
    "main": "Main",
    "expirationDate": "Expiration date",
    
    // Permissions & 2FA
    "permissionsAnd2FA": "Permissions & 2FA",
    "encryptedVideosSection": "Encrypted Videos Section",
    "require2FAForEncryptedVideos": "Require 2FA for encrypted videos section",
    "allowedUsersForEncryptedVideos": "Allowed users for encrypted videos section",
    "allowedUsersHelper": "Select users who can access the encrypted videos section. If no users are selected, no one can access this section.",
    "releaseLevel2FA": "Release-level 2FA",
    "require2FAForRelease": "Require 2FA for this release",
    "releaseLevel2FAIncludesAllSections": "Release-level 2FA already includes all sections (including encrypted videos)",
    "sectionLevel2FAIsMoreSpecific": "Section-level 2FA is more specific and takes precedence over release-level",
    "users": "Users",
    "selectUsers": "Select Users",
    "selectedUsers": "Selected Users",
    "searchUsers": "Search users",
    "confirm": "Confirm",
    "name": "Name",
    "email": "Email",
    "mobile": "Mobile",
    "roles": "Roles"

    // tabs: {
    //   "content": "Content",
    //   "images": "Images",
    //   "videos": "Videos",
    //   "files": "Files",
    //   "links": "Links"
    // }
  },
  "distributeLocales": {
    "distribute": "Distribute",
    "distributions": "Distributions",
    "distributeRelease": "Distribute release",
    "contactsToDistribute": "Contacts to distribute",
    "selfContacts": "Self contacts",
    "contactsWasSelected": "contacts was selected",
    "fromEmail": "From email",
    "fromName": "From name",
    "addCustomContact": "Add contact email",
    "customEmailToAdd": "Contact email / mobile to add",
    "sendTestMail": "Send test mail",
    "confirmAndDistribute": "Confirm and distribute",
    "distributeReleaseConfirmMsg": "Are you sure you want to distribute the release?",

    "remove": "remove",
    "add": "add",
    "addAll": "add all",
    "removeAll": "remove all",
    "mailingList": "Mailing lists",
    "noMailingListsFound": "No mailing lists found",
    "cantCreateEmptyMailingList": "Cant create empty mailing list",
    "saveMailingList": "Save contact list",
    "testEmail": "Test email",

    "sccessfullyDistributedReleaseTo": "Successfully distributed release to",
    "cantSenDistributionTo": "Couldn`t send distribution email to",
    "missingEmailOrMobile": "Missing email or mobile to",
    "alreadyDistributedToContacts": "Already distributed release to",
    "tryAgain": "Try again",
    "backToEditRelease": "Back to edit release",
    "noMatchingDesignTemplateFound": "No matching newsletter design was found",

    "loadDistributionList": "Load distribution list",
    "saveDistributionList": "Save distribution list",

    "report": "Report",
    "reports": "Reports",
    "contactReport": "Contact report",

    "loadingMsg": "Distributing release, it might take a while",
    wached: 'Wached',
    newsOpened: 'Newsletter opened',
    newsletter: 'News letter',
    "enterenceOrigins": 'Enterence Origins',
    copyReleaseDistributionUrl: 'Copy release distribution url',
    'origin': 'Origin',
    'unsubscribed': 'Unsubscribed',
    'wachedCount': 'Wached count',
    'contactReport': 'Contact report',
    origins: {
      email: 'Email',
      distribution: 'Distribution',
      site: 'Site',
      undefined: 'Unknown',
      "distribution-email": 'Distribution email',
      "distribution-sms": 'sms',
    },
    allowReply: 'Allow response',
    forceDistribute: 'Allow redistribute if distributed in the past',

    token: 'Token',
    tokenType: 'Token type',
    tokenTypes: {
      'unique': 'Unique',
      'insert': 'Insert',
      'none': 'None'
    },
    uniqueTokenNote: '',
    regenerateToken: 'Regenerate unique token',
    noDistributionDataForRelease: 'No distribution data for release',

    "unsubscribedContacts": "Unsubscribed contacts",
    "deleteDistributionData": "Delete distribution data",
    "distributionType": "Distribution type",
    "testMode": "Test mode",

    "selectContacts": "Select contacts",

    "alertMsgs": {
      "cantAddContacts": "Somethind went wrong, cant add contacts",
      "successDistRelease": "Successfully distributed release",
      "errorDistRelease": "Something went wrong, cant distribute release",
      "testDistSentSuccess": "Successfully sent test distribution for release",
      "testDistSentError": "Somethind went wrong, cant sent test distribution for release",
      "createMailingListError": "Somethind went wrong, cant create new mailing list",
      "updateMailingListError": "Somethind went wrong, cant update mailing list",
      "noMailingListNameError": "Missing new mailing list name!",
      "confirmRemovemailingListMsg": "Are you sure you want to remove this mailing list?",
      "confirmRemoveDistData": "Are you sure you want to delete all the distribution data of this release and put it back in editing stage?"
    }
  }
}
const he = {
  "releaseLocales": {
    "release": "רליס",
    "releases": "רליסים",
    "editRelease": "עריכת רליס",
    "createRelease": "יצירת רליס",
    "confirmAndDistribute": "אישור והפצה",
    "designAndPreview": "תצוגה מקדימה",
    "landingPageDesign": "עיצוב דף נחיתה",
    "newsletterDesign": "עיצוב מייל הפצה",
    "searchReleases": "חפש רליסים",
    "filterByYear": "בחר שנה",
    "allYears": "כל השנים",
    "addToFolder": "הוסף לתיקייה",
    "alerts": {
      "confirmRemove": "האם אתה בטוח שאתה רוצה למחוק את הרליס?",
      "removeSuccess": "רליס נמחק בהצלחה",
      "savedSuccess": "פרטי רליס נשמרו בהצלחה",
      "leaveConfirm": "האם אתה בטוח שאתה מעוניין לעזוב מבלי לשמור את השינויים?"
    },
    purchase: 'רכש',
    israeliPurchase: 'רכש ישראלי',
    original: 'מקור',

    distributedAt: "הופץ",

    "release": "רליס",
    "releases": "רליסים",
    "monthPublish": "חודש הוצאה לאור",
    "main": "כללי",
    "expirationDate": "תאריך תפוגה",
    
    // Permissions & 2FA
    "permissionsAnd2FA": "הרשאות ואימות דו-שלבי",
    "encryptedVideosSection": "סעיף וידאו מוצפן",
    "require2FAForEncryptedVideos": "דרוש אימות דו-שלבי לסעיף וידאו מוצפן",
    "allowedUsersForEncryptedVideos": "משתמשים מורשים לסעיף וידאו מוצפן",
    "allowedUsersHelper": "בחר משתמשים שיכולים לגשת לסעיף הוידאו המוצפן. אם לא נבחרו משתמשים, אף אחד לא יוכל לגשת לסעיף זה.",
    "releaseLevel2FA": "אימות דו-שלבי ברמת רליס",
    "require2FAForRelease": "דרוש אימות דו-שלבי לרליס זה",
    "releaseLevel2FAIncludesAllSections": "אימות דו-שלבי ברמת רליס כולל כבר את כל הסעיפים (כולל וידאו מוצפן)",
    "sectionLevel2FAIsMoreSpecific": "אימות דו-שלבי ברמת סעיף הוא ספציפי יותר וגובר על אימות ברמת רליס",
    "users": "משתמשים",
    "selectUsers": "בחר משתמשים",
    "selectedUsers": "משתמשים נבחרים",
    "searchUsers": "חפש משתמשים",
    "confirm": "אישור",
    "name": "שם",
    "email": "אימייל",
    "mobile": "נייד",
    "roles": "תפקידים"
    // tabs: {
    //   "content": "תקציר",
    //   "images": "תמונות",
    //   "videos": "צפיה",
    //   "files": "קבצים",
    //   "links": "קישורים"
    // }
  },
  "distributeLocales": {
    "distribute": "הפצה",
    "distributions": "הפצות",
    "distributeRelease": "הפצת רליס",
    "contactsToDistribute": "אנשי קשר להפצה",
    "selfContacts": "ספר כתובות אישי",
    "contactsWasSelected": "אנשי קשר נבחרו",
    "fromEmail": "שלח מ",
    "fromName": "שם השולח",
    "addCustomContact": "הוספת מייל איש קשר",
    "customEmailToAdd": "אימייל / נייד",
    "sendTestMail": "שלח מייל בדיקה",
    "confirmAndDistribute": "אישור והפצה",
    "distributeReleaseConfirmMsg": "האם אתה בטוח שאתה מעוניין להפיץ את הרליס?",

    "remove": "הסר",
    "add": "הוסף",
    "addAll": "הוסף הכל",
    "removeAll": "הסר הכל",
    "mailingList": "רשימת תפוצה",
    "noMailingListsFound": "לא נמצאו רשימות תפוצה",
    "cantCreateEmptyMailingList": "אי אפשר לייצר רשימת תפיצה ריקה",
    "saveMailingList": "שמור רשימת תפוצה",
    "testEmail": "מייל בדיקה",

    "sccessfullyDistributedReleaseTo": "רליס הופץ בהצלחה ל",
    "cantSenDistributionTo": "המערכת לא הצליחה להפיץ רליס ל",
    "missingEmailOrMobile": "חסר מייל או מספר טלפון ל",
    "alreadyDistributedToContacts": "המערכת נמנעה מלהפיץ את הרליס פעם נוספת לחלק מאנשי הקשר מכיוון שכבר הפיצה את הרליס בעבר ל",
    "tryAgain": "נסה שוב",
    "backToEditRelease": "חזור לעריכת רליס",
    "noMatchingDesignTemplateFound": "לא נמצאה תבנית עיצובית מתאימה למייל הפצה",

    "loadDistributionList": "טען רשימת תפוצה",
    "saveDistributionList": "שמור רשימת תפוצה",

    "report": "דוח רליס",
    "reports": "דוחות הפצה",
    "contactReport": "דוח הפצות איש קשר",

    "loadingMsg": "מפיץ את הרליס, זה עשוי לקחת רגע..",
    wached: 'צפייה בתוכן',
    newsOpened: 'ניוזלטר נפתח',
    newsletter: 'ניוזלטר',
    "enterenceOrigins": 'מקורות כניסה',
    copyReleaseDistributionUrl: 'העתק קישור להפצת רליס',
    origin: 'מקור',
    'unsubscribed': 'ביטל מנוי',
    wachedCount: 'צפיות בוידאו',
    'contactReport': 'דוח איש קשר',
    origins: {
      email: 'אימייל',
      distribution: 'הפצה',
      site: 'אתר',
      undefined: '-',
      "distribution-email": 'מייל הפצה',
      "distribution-sms": 'sms',
    },
    allowReply: 'אפשר תגובה',
    forceDistribute: 'אפשר להפיץ בשנית אם כבר הופץ בעבר',

    token: 'מזהה',
    tokenType: 'סוג מזהה',
    tokenTypes: {
      'unique': 'ייחודי',
      'insert': 'הזן',
      'none': 'ללא'
    },
    uniqueTokenNote: 'שימו לב - שימוש במזהה ייחודי (או ייחודי בהזנה) עוזר למערכת לספור כמה פעמים הרליס נפתח על ידי נמענים שונים. במידה ולא נעשה שימוש במזהה ייחודי, המערכת תחשיב כל פתיחה של הרליס מאותו הקישור כפתיחה חדשה שנעשתה ידי נמען אחר.',
    uniqueTokenNote: 'שימו לב - שימוש במזהה ייחודי (או ייחודי בהזנה) עוזר למערכת לספור כמה פעמים הרליס נפתח על ידי נמענים שונים. במידה ולא נעשה שימוש במזהה ייחודי, או במידה ואותו קישור עם אותו מזהה נשלח למספר נמענים שונים - המערכת תחשיב כל פתיחה של הרליס מאותו הקישור כפתיחה שנעשתה על ידי אותו נמען. מומלץ ליצור מזהה ייחודי חדש (או להזין מזהה ייחודי באופן ידני) לכל נמען.',
    urlDistributionNote: 'לאחר פתיחת הקישור ובמידה ולא הופץ לפני - הרליס ייחשב במערכת כרליס שהופץ.',
    regenerateToken: 'צור מזהה ייחודי חדש',
    noDistributionDataForRelease: 'לא נמצא תקציר הפצה לרליס',
    "onlyRegularDistributionValidMsg": "שימו לב! בארגון זה יש צורך באימות לפני צפיה בתכנים, לכן הקישור יעבוד אך ורק לנמענים אשר הרליס כבר הופץ להם בעבר באופן רגיל ולא דרך קישור הפצה.",

    "unsubscribedContacts": "אנשי קשר שבטלו הרשמה",
    "deleteDistributionData": "מחק תקציר הפצה",
    "distributionType": "סוג הפצה",
    "testMode": "מצב בדיקה",

    "selectContacts": "בחר אנשי קשר להפצה",

    "alertMsgs": {
      "cantAddContacts": "משהו השתבש, לא יכול להוסיף איש קשר",
      "successDistRelease": "רליס הופץ בהצלחה",
      "errorDistRelease": "משהו השתבש, המערכת לא הצליחה להפיץ את הרליס",
      "testDistSentSuccess": "מייל בדיקה נשלח בהצלחה",
      "testDistSentError": "המערכת לא הצליחה לשלוח מייל בדיקה",
      "createMailingListError": "המערכת לא הצליחה ליצור רשימת תפוצה",
      "updateMailingListError": "המערכת לא הצליחה לעדכן את רשימת התפוצה",
      "noMailingListNameError": "צריך להזין שם לרשימת תפוצה חדשה!",
      "confirmRemovemailingListMsg": "האם אתה בטוח שאתה מעוניין למחוק את רשימת התפוצה?",
      "confirmRemoveDistData": "האם אתה בטוח שאתה מעוניין למחוק את תקציר ההפצה של רליס זה ולהחזיר אותו למצב עריכה?"
    }
  }
}
const heF = {
  ...he,
  releaseLocales: {
    ...he.releaseLocales,
    alerts: {
      ...he.releaseLocales.alerts,
      "confirmRemove": "האם את בטוחה שאת רוצה למחוק את הרליס?",
    }
  }
}
export const releaseLocales = {
  en,
  he,
  heF
}